import { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { Car } from '../types/CarTypes';
import './CarInput.css';

type CarInputProps = {
  disabled: boolean
  options: Array<Car>
  onCarSelected?: (car: Car) => void
}

const filter = (cars: Array<Car>, text: string):Array<Car> => {
  if (!text) return [];

  const lower = text.toLowerCase();
  const parts = lower.split(' ');

  if (parts.length === 1) {
    return cars.filter(car => (car.manufacturer.name.toLowerCase().startsWith(lower) ||
      car.model.toLowerCase().includes(lower)))
  }

  const manuName = parts[0];
  const modelName = parts[1];

  return cars.filter(car => 
    car.manufacturer.name.toLowerCase().startsWith(manuName) &&
      car.model.toLowerCase().includes(modelName));
}


const PLACEHOLDER = "Search for a make/model"
export const CarInput: React.FC<CarInputProps> = ({disabled, options, onCarSelected}) => {
  const [chosenText, setChosenText] = useState("");

  const handleUserKeyPress = useCallback((event: { key: any; keyCode: any; }) => {
    if (disabled) {
      return false;
    }
    const { key, keyCode } = event;

    if (keyCode === 32 || (keyCode >= 48 && keyCode <= 57) || (keyCode >= 65 && keyCode <= 90)) {
      setChosenText(prevUserText => `${prevUserText}${key}`);
    }
    // Backspace
    if (keyCode === 8) {
      setChosenText(prevUserText => prevUserText.substring(0, prevUserText.length -1));
    }
    return false;
  }, [disabled]);
  
  useEffect(() => {
    window.addEventListener('keydown', handleUserKeyPress);

    return () => {
      window.removeEventListener('keydown', handleUserKeyPress);
    };
  }, [handleUserKeyPress]);


  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    return false;
  };

  const validOptions = filter(options, chosenText);

  const handleClick = (carIndex: number) => {
    onCarSelected && onCarSelected(validOptions[carIndex]);
    setChosenText("");
  };


  return (        
  <section className="CarInput">
        <ul>
    {validOptions.map( (carOption, index) => 
        <li className="tube" key={`${carOption.manufacturer}-${carOption.model}`} onClick={() => handleClick(index)}>
          {carOption.manufacturer.name} <i>{carOption.model}</i>
        </li>
      )}
    </ul>
    <img className="searchIcon" src="/magnifying-glass.svg" alt="search" />
    <input 
      type="text"
      autoFocus
      placeholder={PLACEHOLDER}
      onChange={handleChange} 
      value={chosenText}></input>
  </section>)
}